import React from 'react';

const About = () => (
  <div className="content-container">
    <div className="content-title-group not-found">
      <h2 className="title">Product Wish List</h2>
      <p>
        This is some text.  This is some more text
      </p>
      <br />
      <h2 className="title">Resources</h2>
      <ul>
        <li>
          <a href="https://github.com/MicrosoftDocs/mslearn-staticwebapp">
            Code in GitHub
          </a>
        </li>
      </ul>
    </div>
  </div>
);

export default About;
